import { removeEmptyValues } from '~/utils';
import { camelToSnakeObject } from '~~/utils';

// Drops empty values (per spec: inactive filters must not appear in the
// payload) and snake-cases keys to match the wire schema.
export function pickActiveFilters(
	filters: Record<string, unknown> | null | undefined
): Record<string, unknown> {
	if (!filters) return {};

	const active = removeEmptyValues(filters);
	return camelToSnakeObject(active as Record<string, unknown>);
}
